export default __webpack_public_path__ + "static/media/IconTwitter.93bffd2d.svg";